import { getDirectoryLocationQuery, getEventProximityQuery } from "./eventDiscovery";

export function getHomeEventQuery({
  dateFilter,
  radius,
  genres,
  query,
  accessibleOnly,
  locationChip,
  discoveryLocation,
}) {
  const nearMe = locationChip === "Near me";
  const proximity = nearMe
    ? getEventProximityQuery(radius, discoveryLocation)
    : {};

  return {
    q: query,
    upcomingOnly: true,
    dateRange: dateFilter,
    radiusKm: nearMe
      ? proximity.radiusKm
      : Number.isFinite(radius)
        ? radius
        : undefined,
    genres: genres?.length && !genres.includes("All") ? genres : ["All"],
    accessibility: accessibleOnly ? ["Wheelchair"] : [],
    city: nearMe ? undefined : locationChip,
    latitude: proximity.latitude,
    longitude: proximity.longitude,
  };
}

export function getHomeDirectoryQuery(
  query,
  {
    locationChip = "Anywhere",
    radiusKm,
    discoveryLocation,
    genres,
    accessibleOnly,
  } = {}
) {
  const normalizedQuery = String(query || "").trim();

  return {
    query: normalizedQuery || undefined,
    page: 1,
    pageSize: 8,
    ...(genres?.length && !genres.includes("All") ? { genres } : {}),
    ...(accessibleOnly ? { accessibility: ["Wheelchair"] } : {}),
    ...getDirectoryLocationQuery(locationChip, radiusKm, discoveryLocation),
  };
}

export function readHomeFilterState(searchParams, defaults = {}) {
  const rawRadius = searchParams.get("radius");
  const parsedRadius = rawRadius === "all" ? null : Number(rawRadius);
  const genres = searchParams.getAll("genre").filter(Boolean);

  return {
    locationChip: searchParams.get("location") || defaults.locationChip || "Near me",
    dateFilter: searchParams.get("date") || "All",
    radius: rawRadius && (rawRadius === "all" || Number.isFinite(parsedRadius))
      ? parsedRadius
      : defaults.radius,
    genres: genres.length ? genres : ["All"],
    accessibleOnly: searchParams.get("accessible") === "1",
  };
}

export function writeHomeFilterState(searchParams, filters, defaults = {}) {
  const next = new URLSearchParams(searchParams);
  const defaultLocation = defaults.locationChip || "Near me";

  if (filters.locationChip && filters.locationChip !== defaultLocation) next.set("location", filters.locationChip);
  else next.delete("location");

  if (filters.dateFilter && filters.dateFilter !== "All") next.set("date", filters.dateFilter);
  else next.delete("date");

  if (filters.radius === null) next.set("radius", "all");
  else if (filters.radius !== defaults.radius) next.set("radius", String(filters.radius));
  else next.delete("radius");

  next.delete("genre");
  if (!(filters.genres.length === 1 && filters.genres[0] === "All")) {
    filters.genres.forEach((genre) => next.append("genre", genre));
  }

  if (filters.accessibleOnly) next.set("accessible", "1");
  else next.delete("accessible");
  return next;
}
